import { httpClient } from './../httpClient';

export const getConversation = (ota, sourceId) => {
  console.log('getConversation', ota, sourceId);
  return httpClient
    .get(`/conversation/${ota}/${sourceId}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getBookingcomConversation = code => {
  return httpClient
    .get(`/bookingcom/conversationByResId/${code}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getCtripCMConversation = code => {
  return httpClient
    .get(`/ctripv2/conversationByResId/${code}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAirbnbConversationByConfirmationCode = confirmationCode => {
  return httpClient
    .get(`/airbnb/conversationByResId/${confirmationCode}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAirbnbThreadByListingIdAndSourceId = (unitId, sourceId) => {
  return httpClient
    .get(`/airbnb/getThreadBySourceId/${unitId}/${sourceId}`)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getUnreadCount = (hostId, canViewAllChats) => {
  console.log('Fetching unread count for hostId:', hostId);
  return httpClient
    .get(`/conversation/unread-count`, { params: { hostId, childHost: canViewAllChats } })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error.response;
    });
};
